<script>
  export var items;
  export var activeTabId;
  export var tabclass = "tabnav";
  export var tabs = true;
  export var closeTab = false;
  export var name = null;

  import {Button, Nav, NavItem, NavLink} from 'sveltestrap';
  import { setContext } from 'svelte';
  import { writable } from 'svelte/store';
  import { hash, hashState } from './hash.js';
  const ctxKey="TabPanelStack";


  function syncFromHash(pos) {
    if (name) {
      if (location.hash) {
        var value = hash()[name];
        if (value) {
          var found = vfound(); // checks it is present, plus some debug
          if (found) {
            activeTabId = value;
          } else {
            console.log("tabnav syncFromHash item not found for setting", name, value, items.map(item=>item.id || item.label))
          }
        }
      }
    }
  }

  function tabclick(item) {
    // console.group("tabclick-"+name)
    activeTabId = item.id || item.label    
    syncToHash("click")
    // console.groupEnd();
  }

  var syncing=false;
  function syncToHash(pos) {
    if (name) {
      syncing=true
      var map = hash();
      //console.log("tabnav syncToHash", name, map[name], pos)
      if (activeTabId && map[name] != activeTabId) {
        map[name]=activeTabId;
        location.hash="#"+Object.entries(map).filter(e=>e[0]).reduce((s,kv)=>(s+=kv[0]+"="+kv[1]+"&"),"").replace(/&$/,'')
      }
      syncing=false;
    }
  }

  let atw = writable(activeTabId);
  setContext(ctxKey, atw);
  $: {
    //console.log("tabnav $$", name, activeTabId)
    atw.set(activeTabId);
    // syncToHash("$");
  }

  var tabFound = false;

  var vfound = () =>{
    var value = hash()[name]
    var is = items.filter(item=>item.id == value || item.label == value).shift()
    if (is && !tabFound) {
      tabFound = true;
      // just found
      //console.log("TabNav ", name, " just found -------------------", value)
    }
    return is;
  }

  hashState.subscribe(value => {
    //console.group("TabNav hash subs "+name, syncing)
    //console.log("TabNav hash subs for value", name, value); 
    syncFromHash("subs")
    vfound();
    console.groupEnd();
  })


  //console.log("tabnav init", name, activeTabId, items.length)//, new Error().stack)
  hashState.update(value => (value[name+"_init"]=null,value))

  function labelDragenter(id) {
    console.log(id)
    activeTabId = id;
  }
  syncFromHash("init")
</script>

<div class={tabclass} id={tabclass} >
  <Nav tabs={tabs} pills={!tabs} {...$$restProps}>
    {#each items as item}
      {#if !item.onclick}
      <NavItem>
        <NavLink 
          active={activeTabId == (item.id || item.label)} 
          on:click={()=>{tabclick(item)}}
          title={item.label}
          >
          {#if item.icon}
            <span title={item.label}><i class="fa fa-{item.icon}" ></i></span>
          {:else}
            <span class="navlabel" on:dragenter={()=>labelDragenter(item.id || item.label)}>{item.label}</span>
          {/if}
          {#if item.closeable }
          <span title='Close tab' on:click={()=>closeTab(item.id || item.label)}><i class="fa fa-window-close" ></i></span>
          {/if}
        </NavLink>
      </NavItem>
      {/if}
    {/each}
    <div class="ml-auto"> </div>
    {#each items as item}
      {#if item.onclick}
        <Button on:click={item.onclick} class="btn-sm ml-1 mb-1 mt-1">{item.label}</Button>
      {/if}
    {/each}
  </Nav>
  <slot />
</div>
